import {Pipe, PipeTransform} from '@angular/core';
import {RegularUnitAdvertisementDto} from "homey-housing-lottery-app-dto";

export const getMaxRent = (advertisements: RegularUnitAdvertisementDto[]) => {
  return Math.max(...advertisements.map(advertisement => advertisement.monthlyRent));
}

@Pipe({
  name: 'maxRent',
  standalone: true
})
export class MaxRentPipe implements PipeTransform {
  transform(advertisements: RegularUnitAdvertisementDto[]): number {
    return getMaxRent(advertisements);
  }
}
;
